import { Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faExchangeAlt } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'wilson-timeline-modal-legend',
  imports: [TranslateModule, FontAwesomeModule],
  templateUrl: './timeline-modal-legend.component.html',
  styleUrls: ['./timeline-modal-legend.component.scss'],
})
export class TimelineModalLegendComponent {
  public faExchange = faExchangeAlt;
}
